import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import FormatHelper from "@client.utils/FormatHelper";
import "./DetailedTooltip.scss";

const DetailedTooltip = ({
  barPosition,
  width,
  payload,
  onMouseEnter,
  onMouseLeave,
  getTooltipContent,
}) => {
  const { t } = useTranslation();
  const tooltipContent = getTooltipContent
    ? getTooltipContent(payload)
    : FormatHelper.getCountableTermValue(
        t,
        "components.ChartWithDetailedTooltip.meetingsTooltip",
        payload.meetings.length,
        {
          qty: payload.meetings.length,
          value: payload.value,
        }
      );
  const getAdjustedTooltipPosition = () => {
    const { x, y } = barPosition;
    const detailedTooltipId = `detailed-tooltip-content`;
    let span = document.getElementById(detailedTooltipId);

    if (!span) {
      const div = document.createElement("div");
      div.className = "tooltip detailed-tooltip";
      div.style.visibility = "hidden";
      div.style.position = "fixed";

      span = document.createElement("span");
      span.id = "detailed-tooltip-content";
      span.innerHTML = tooltipContent;
      div.append(span);

      document.body.appendChild(div);
    }

    span.innerHTML = tooltipContent;
    const div = span.parentElement;

    let adjustedX = x;
    const spaceAtRight = window.innerWidth - (x + div.offsetWidth);

    if (spaceAtRight < 0) {
      adjustedX = x - div.offsetWidth - width - 2;
    }

    let adjustedY = y;

    const spaceAtTop = y - div.offsetHeight;
    if (spaceAtTop >= 0) {
      adjustedY = spaceAtTop;
    }

    return { left: adjustedX, top: adjustedY };
  };

  return (
    <div
      className="tooltip detailed-tooltip"
      style={getAdjustedTooltipPosition()}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {tooltipContent}
    </div>
  );
};

DetailedTooltip.propTypes = {
  barPosition: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number,
  }),
  width: PropTypes.number,
  payload: PropTypes.any,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  getTooltipContent: PropTypes.func,
};

export default DetailedTooltip;
